import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IDashboardState } from '../states/aumye-dashboard.state';

export const selectDashboardState = createFeatureSelector<IDashboardState>(
  'aumyeDashboardState'
);

export const selectOrgUsersData = createSelector(
  selectDashboardState,
  (state) => state.orgUserList
);
